import { Stack } from '@mui/material'
import React from 'react'
import { InstallationWithoutAccess } from 'src/Libs/installations/models'
import InstallationLink from './InstallationLink'
import InstallationWithoutAccessImage from './InstallationWithoutAccessImage'
import InstallationWithoutAccessOwnerName from './InstallationWithoutAccessOwnerName'
import NoAccessToInstallationTooltip from './NoAccessToInstallationTooltip'

interface Props {
  installation: InstallationWithoutAccess
}

/**
 * Display installation information for installations without access in mobile view.
 */
const InstallationWithoutAccessInformationMobile: React.FC<Props> = ({ installation }) => {
  return (
    <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
      <Stack flexDirection="row" alignItems="center" gap={2}>
        <InstallationWithoutAccessImage installation={installation} />
        <Stack>
          <InstallationLink installation={installation} />
          <InstallationWithoutAccessOwnerName installation={installation} />
        </Stack>
      </Stack>
      <NoAccessToInstallationTooltip installation={installation} />
    </Stack>
  )
}

export default InstallationWithoutAccessInformationMobile
